import { render } from "./ModalQuotationDetailB2b.vue?vue&type=template&id=1df45202&scoped=true"
import script from "./ModalQuotationDetailB2b.vue?vue&type=script&lang=js"
export * from "./ModalQuotationDetailB2b.vue?vue&type=script&lang=js"

import "./ModalQuotationDetailB2b.vue?vue&type=style&index=0&id=1df45202&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1df45202"]])

export default __exports__